import {
  CreditorType,
  TemporaryAccessTokensObject,
  VerificationMethod,
} from "@gocardless/api/dashboard/types";

import { CountryCodeSupported } from "src/common/country";
import { SignUpAccountType } from "src/components/routes/SignUp/SignUp";
import {
  ReferralEmailSource,
  ReferralEmailVariation,
} from "src/common/trackingEventAttributes";

export enum SignUpFormField {
  email = "email",
  organisation_name = "organisation_name",
  geo = "geo",
  password = "password",
  terms_and_conditions = "terms_and_conditions",
  creditor_type = "creditor_type",
}

export interface SignupFormData {
  email: string;
  geo: string;
  password: string;
  business_name: string;
  terms_and_conditions: boolean;
  creditor_type: CreditorType;
  verification_method: VerificationMethod;
}

export interface EmailVerificationFormData {
  verificationCode?: string;
  organisationName?: string;
}

export const VerificationCodeAllowedChar = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "Backspace",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "Enter",
  "v",
];

export interface RegistrationResponse {
  linked: {
    temporary_access_tokens: TemporaryAccessTokensObject;
  };
  registrations: {
    organisation_created_at: string;
    cpv_enabled?: boolean;
    links: {
      creditor: string;
      organisation: string;
      temporary_access_token: string;
    };
  };
}

export interface RegistrationParams extends Partial<SignupFormData> {
  accountType: SignUpAccountType;
  referralGeo?: string | null;
  referralCode?: string | null;
  hasFsbMemberDiscount?: boolean;
  referralSource?: ReferralEmailSource | null;
  referralEmailVariation?: ReferralEmailVariation | null;
  referralCodeName?: string | null;
}

export enum SignUpAPIErrors {
  ValidationFailed = "validation_failed",
}

export enum SignUpEvents {
  BusinessLocationChanged = "Merchant sign up  - Default business location has been changed",
}

export enum WebsiteLinks {
  PRIVACY_POLICY = "https://gocardless.com/privacy/",
  TERMS_AND_CONDITIONS = "https://gocardless.com/legal/",
  REFERRAL_SCHEME_TERMS = "https://gocardless.com/g/referral-scheme-v2/",
  REGULATORY_INFO = "https://gocardless.com/g/regulatory-info/",
  ESIGN_TERMS = "https://assets.ctfassets.net/40w0m41bmydz/4YN1KXEZzSgYoCvnNpPPp/3d77ab59f92db822c5665c0d90f76bf2/GoCardless_E-Sign_Terms_-_Merchants_-_October_2023.pdf",
  SANCTIONS_AGREEMENT = "https://gocardless.com/legal/sanctions-terms/",
  SANCTIONS_AGREEMENT_ES = "https://gocardless.com/es-es/legal/acuerdo-de-sanciones-de-gocardless/",
  SANCTIONS_AGREEMENT_FR = "https://gocardless.com/fr-fr/legal/convention-de-sanction-gocardless/",
  SANCTIONS_AGREEMENT_DE = "https://gocardless.com/de-de/rechtliches/gocardless-sanktionsvereinbarung/",
}

export enum ValidationMode {
  OnBlur = "onBlur",
  OnChange = "onChange",
  OnSubmit = "onSubmit",
  OnTouched = "onTouched",
  All = "all",
}

export const PopularCountryCodes: CountryCodeSupported[] = [
  CountryCodeSupported.GB,
  CountryCodeSupported.US,
  CountryCodeSupported.AU,
  CountryCodeSupported.FR,
  CountryCodeSupported.NZ,
];

export const OB_SEARCH_QUERY_KEY = "gc.ob.search.query";

export enum ButtonFeedbackEnum {
  Default = "default",
  IsLoading = "isLoading",
  IsSuccessful = "isSuccessful",
}
